import React from "react";
import Banner from "../comman/Banner/Banner";
import Productrange from "../components/Home/Productrange";
// import Productdetails from "../components/Home/Productdetails";
import Productyoutube from "../components/Home/Productyoutube";
import Companysince from "../components/Home/Companysince";
// import Companyrewards from "../components/Home/Companyrewards";
import Companyrules from "../components/Home/Companyrules";
// import Producthighrange from "../components/Home/producthighrange";
// import ContactForm from "../components/Home/ContactForm";
import Testimonials from "../components/Home/Testimonials";
// import Companyexperinece from "../components/Home/Companyexperinece";


const Home = () => {
  return (
    <>
      <Banner
        index={'home'}
      />
      {/* <Companyexperinece /> */}
      <Productrange />
      {/* <Productdetails /> */}
      <Companysince />
      <Productyoutube />

      {/* <Companyrewards/> */}
      <Companyrules />
      {/* <Producthighrange/> */}
      {/* <ContactForm/>     */}
      <Testimonials />

    </>
  )
};

export default Home;